import { memo } from 'react';

import { CarSelectionCard } from '@/components/sections/product-compare/car-selection-card';
import { CompareDetails } from '@/components/sections/product-compare/compare-details';
import {
  CompareSelects,
  CompareSelectsProps,
} from '@/components/sections/product-compare/compare-selects';
import { Container } from '@/components/shared/layout/container';
import { Grid } from '@/components/shared/layout/grid';
import {
  HANDLE_PRODUCT_URL_BY_MODEL,
  HANDLE_REGISTER_URL_BY_MODEL,
} from '@/const/product';
import {
  LCV_COMPARE_FEATURES,
  LCV_COMPARE_REMARK,
  LCV_COMPARE_SUMMARY,
} from '@/contents/lcv/lcv-compare';
import { LcvModel } from '@/services/contentstack/models/lcv-model';
import { LcvModelColor } from '@/services/contentstack/models/lcv-model-color';
import { styled } from '@/stitches.config';

const CompareWrapperStyled = styled(Grid, {
  gridTemplateRows: 'repeat(7,auto)',
});

interface ProductCompareLCVProps extends CompareSelectsProps {
  activeSliderIndex: number;
  models: LcvModel[];
  colors: LcvModelColor[];
  onColorChange: (index: number, color: LcvModelColor) => void;
  onChangeActiveSlider: (index: number) => void;
}
const ProductCompareLCV: React.FC<ProductCompareLCVProps> = ({
  optionGroups,
  selectedModelKeys,
  activeSliderIndex,
  models,
  colors,
  onModelChange,
  onColorChange,
  onChangeActiveSlider,
}) => {
  const onHandleColorChange = (index: number, color: LcvModelColor) => {
    onColorChange(index, color);
    onHandleSlideChange(index);
  };
  const onHandleSlideChange = (index: number) => {
    onChangeActiveSlider(index);
  };

  return (
    <Container>
      <CompareSelects
        optionGroups={optionGroups}
        selectedModelKeys={selectedModelKeys}
        onModelChange={onModelChange}
      />
      <CompareWrapperStyled
        templateColumns={{ '@initial': '2', '@lg': '3' }}
        columnGap={{ '@initial': '4', '@md': '6' }}
        rowGap="4"
        autoFlow="column"
      >
        {models.map((model, modelIndex) => (
          <CarSelectionCard
            key={modelIndex}
            activeSliderIndex={activeSliderIndex}
            index={modelIndex}
            name="car-selection-lcv"
            model={{
              ...model,
              modelCategory: model?.lcv_model_class[0].category[0].name_th,
              modelName: model?.name,
              modelColor: colors[modelIndex],
            }}
            showColor
            onChangeColor={(color) => onHandleColorChange(modelIndex, color)}
            onChangeSlide={() => onHandleSlideChange(modelIndex)}
            onClickSlide={() => onHandleSlideChange(modelIndex)}
            buttonLink={{
              register: {
                url: model && HANDLE_REGISTER_URL_BY_MODEL(model),
              },
              detail: {
                url: model && HANDLE_PRODUCT_URL_BY_MODEL(model),
              },
            }}
            css={
              modelIndex === 2 ? { '@maxlg': { display: 'none' } } : undefined
            }
          />
        ))}
      </CompareWrapperStyled>
      <CompareDetails
        summary={LCV_COMPARE_SUMMARY}
        remark={LCV_COMPARE_REMARK}
        feature={LCV_COMPARE_FEATURES}
        models={models}
      />
    </Container>
  );
};

ProductCompareLCV.displayName = 'ProductCompareLCV';
export default memo(ProductCompareLCV);
